module.exports = __webpack_public_path__ + "static/media/2.Naming-Preferences.19dc3638.png";